import { render, staticRenderFns } from "./ResponseStatusList.vue?vue&type=template&id=35b881e4"
import script from "./ResponseStatusList.vue?vue&type=script&lang=ts"
export * from "./ResponseStatusList.vue?vue&type=script&lang=ts"
import style0 from "./ResponseStatusList.vue?vue&type=style&index=0&id=35b881e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports